module.exports = __webpack_public_path__ + "img/cs2.99823f22.jpg";